import React from 'react';
import { gettext } from '@eventbrite/i18n';

import { Divider } from '@eventbrite/eds-divider';

const Link = ({ link }) => (
    <li className="eds-l-mar-bot-2">
        <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="eds-text-weight--heavy"
        >
            {link.title}
        </a>
    </li>
);

const SubSection = ({ subSection }) => (
    <div className="eds-l-mar-bot-8">
        {subSection.title && (
            <p className="eds-text-bl eds-l-mar-bot-4">
                <a name={subSection.title.replace(/ /g, '-').toLowerCase()}></a>
                {subSection.title}
            </p>
        )}
        {subSection.content}
        {subSection.applicationLink && (
            <div className="eds-l-mar-top-2">
                <a
                    href={subSection.applicationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="eds-text-weight--heavy"
                >
                    Apply
                </a>
            </div>
        )}
        {subSection.infoLink && (
            <div className="eds-l-mar-top-2">
                <a
                    href={subSection.infoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="eds-text-weight--heavy"
                >
                    More info
                </a>
            </div>
        )}
    </div>
);

const SubSections = ({ subSections }) => {
    const subSectionsContent = subSections.map((subSection) => (
        <SubSection subSection={subSection} key={subSection.title} />
    ));
    return <div>{subSectionsContent}</div>;
};

const CountrySection = ({ section }) => {
    const linksContent = section.links.map((link) => (
        <Link link={link} key={link.title} />
    ));

    const sectionAnchor = section.title.replace(/ /g, '-').toLowerCase();

    return (
        <div>
            <h2 className="eds-g-cell eds-g-cell-mn-4-12 eds-g-sm-cell-1-1 eds-text-hs eds-l-pad-right-12">
                <a name={sectionAnchor}></a>
                {section.title}
            </h2>
            <div className="eds-g-cell eds-g-cell-mn-8-12 eds-g-sm-cell-1-1 eds-text-bm">
                {section.subSections && (
                    <SubSections subSections={section.subSections} />
                )}
                {section.content}
                {section.links.length > 0 && (
                    <div>
                        <p className="eds-text-bl eds-l-mar-top-6">
                            {gettext('Links')}
                        </p>
                        <ul>{linksContent}</ul>
                    </div>
                )}
                <div className="eds-l-mar-vert-16">
                    <Divider />
                </div>
            </div>
        </div>
    );
};

export default CountrySection;
